import React from "react";
import logo from "../../image/owner3_logo.png"

export default class Logo extends React.Component {
    render(){
        return <img src={logo} alt="owner logo"/>
    }
}